
export default {
  namespaced: true,
  state: {
    calculatePeriod: [],
    chartLabels: [],
    chartData: []
  },
  getters: {
    calculatePeriod (state) {
      return state.calculatePeriod
    },
    chartLabels (state) {
      return state.chartLabels
    },
    chartData: (state) => {
      let result = [{
        label: 'Oportunidades Reales',
        data: state.chartData,
        backgroundColor: 'rgba(255,0,0,0.6)',
        borderColor: '#E7120E',
        lineTension: 0,
        pointBackgroundColor: '#fff',
        radius: 4,
        pointBorderWidth: 2
      }]
      return result
    }
  },
  mutations: {
    calculatePeriod (state, payload) {
      state.calculatePeriod = payload
    },
    chartData (state, payload) {
      state.chartData = payload
    },
    chartLabels (state, payload) {
      state.chartLabels = payload
    }
  },
  actions: {
    calculatePeriod ({commit}, payload) {
      commit('chartData', payload.chartData)
      commit('chartLabels', payload.chartLabels)
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dash.store.js